import { connect, useDispatch, useSelector } from 'react-redux';
import { useParams, useSearchParams, useNavigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { notification } from 'antd';
import Logger from 'shared/utils/Logger';
import { KnowledgePageComponent } from './knowledge.page.component';
import {
  getCategoryById,
  getCategoriesById,
  getRoot,
} from 'shared/store/selectors/knowledge.selector';
import {
  getSelectedWorkspace,
  getSelectedWorkspaceId,
  getWorkspaceById,
} from 'shared/store/selectors/workspace.selector';
import { selectWorkspace } from 'shared/store/actions/workspace.actions';
import { getLang } from 'shared/store/selectors/lang.selector';

const mapStateToProps = ({ knowledge, workspace }, ownProps) => {
  let { id } = ownProps;

  let isRoot = !id;

  let category = isRoot ? getRoot(knowledge) : getCategoryById(knowledge, { id });

  let children = getCategoriesById(knowledge, category.id);

  const workspaceName = getSelectedWorkspace({ workspace })?.name;

  return {
    id: category.id,
    ...category,
    title: isRoot ? workspaceName : category.title,
    children,
    isRoot,
    isReady: knowledge.isReady,
    workspaceName,
  };
};

const ConnectedKnowledgePage = connect(mapStateToProps)(KnowledgePageComponent);

export const KnowledgePage = () => {
  const routeParams = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const workspaceParam = searchParams.get('workspace');
  const currentWorkspaceId = useSelector(getSelectedWorkspaceId);
  const targetWorkspace = useSelector(getWorkspaceById(workspaceParam));
  const drawerLang = useSelector(getLang('DRAWER'));
  const headerLang = useSelector(getLang('HEADER'));

  useEffect(() => {
    if (!workspaceParam) return;

    const cleanUrl = () => {
      const nextParams = new URLSearchParams(searchParams);
      nextParams.delete('workspace');
      const remaining = nextParams.toString();
      navigate(`${location.pathname}${remaining ? `?${remaining}` : ''}${location.hash}`, {
        replace: true,
      });
    };

    if (workspaceParam === currentWorkspaceId) {
      cleanUrl();
      return;
    }

    dispatch(selectWorkspace(workspaceParam))
      .then(() => {
        if (targetWorkspace?.name) {
          notification.success({
            message: headerLang.CHANGE_WORKSPACE_SUCCESS.replace('{name}', targetWorkspace.name),
            placement: 'bottomLeft',
            duration: 10,
          });
        }
        cleanUrl();
      })
      .catch(error => {
        Logger.error('Failed to switch workspace:', { error });
        notification.error({
          message: drawerLang.CHANGE_WORKSPACE_FAILED,
          placement: 'bottomRight',
        });
        cleanUrl();
      });
  }, [workspaceParam]); // eslint-disable-line react-hooks/exhaustive-deps

  return <ConnectedKnowledgePage {...routeParams} />;
};
